export default __webpack_public_path__ + "assets/webm/13471d936e2e986eb08a45343b9f2ab9.webm";